/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A UTC-day activation bucket for one attributed skill version.
 */
export type SkillSightingTimelinePoint = {
  /**
   * Activations observed during the day.
   */
  activationCount: number;
  /**
   * Start of the UTC day.
   */
  bucketStart: Date;
  /**
   * The attributed skill version, absent when the observation could not be resolved to a version.
   */
  skillVersionId?: string | undefined;
};

/** @internal */
export const SkillSightingTimelinePoint$inboundSchema: z.ZodMiniType<
  SkillSightingTimelinePoint,
  unknown
> = z.pipe(
  z.object({
    activation_count: z.int(),
    bucket_start: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    skill_version_id: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "activation_count": "activationCount",
      "bucket_start": "bucketStart",
      "skill_version_id": "skillVersionId",
    });
  }),
);

export function skillSightingTimelinePointFromJSON(
  jsonString: string,
): SafeParseResult<SkillSightingTimelinePoint, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SkillSightingTimelinePoint$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SkillSightingTimelinePoint' from JSON`,
  );
}
